<template>
  <div>
    <h3>Letter Templates</h3>
    <div class="container">
        <form @submit.prevent="loadData" class="form-horizontal">
            <div class="form-group">
                <div class="col-md-2">
                    <label for="searchName">Search Template Name</label>
                </div>
                <div class="col-md-4">
                    <input class="form-control" type="text" name="searchName" v-model="searchDto.templateName">
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-2">
                    <label for="searchDbNumber">Search Template Type</label>
                </div>
                <div class="col-md-4">
                    <select class="form-control" name="searchTemplateType" v-model="searchDto.letterTemplateTypeId">
                        <option :value="null">All</option>
                        <option :value="-1">All Unassigned</option>
                        <option v-for="type in templateTypeList" :value="type.id" :key="type.id">{{type.description}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-2">
                    <label for="searchDbNumber">Search Assigned Workflow</label>
                </div>
                <div class="col-md-4">
                    <select class="form-control" name="searchWorkflowStatus" v-model="searchDto.workflowStatusId">
                        <option :value="null">All</option>
                        <option :value="-1">All Unassigned</option>
                        <option v-for="status in allWorkflowStatusList" :value="status.workflowStatusId" :key="status.workflowStatusId">{{status.description}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-2">
                    <button class="btn btn-primary" type="submit" name="button" v-on:click="loadData">Search</button>
                </div>
            </div>
        </form>
    </div>
    <div class="wrapper">
      <div  class="row row-wider">
        <div class="col-md-12">
          <div class="pull-right">
            <router-link to="/LetterTemplate" tag="button" class="btn btn-primary btn-block">Add New</router-link>
          </div>
          <loader v-if="loading"/>
          <div>
            <v-client-table :data="gridSpec.tableData" :columns="gridSpec.columns" :options="gridSpec.options">
              <template slot="edit" slot-scope="props">
                <div style="text-align: center;">
                    <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.letterTemplateId)"></a> -->
                    <router-link :to="{ path: '/LetterTemplate/' + props.row.letterTemplateId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                </div>
              </template>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import loggingService from '../services/util/loggingService'
    import letterTemplateService from '../services/letterTemplateService'
    import workflowService from '../services/workflowService'

    import loader from '../components/Loader.vue'

    export default {
        components: {
            loader
        },
        data: function () {
            return {
                isDebug: false,
                loading: true,
                searchDto: {
                    templateName: '',
                    letterTemplateTypeId: null,
                    workflowStatusId: null
                },
                templateTypeList: [],
                allWorkflowStatusList: [],
                gridSpec: {
                    columns: ['edit', 'templateName', 'templateType', 'workflowDescription', 'createdDate'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 10,
                        perPageValues: [10, 25, 50, 100],
                        dateColumns: ['createdDate'],
                        headings: {
                            templateName: 'Template Name',
                            templateType: 'Template Type',
                            workflowDescription: 'Assigned Workflow',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: true,
                            column: 'templateName'
                        }
                    }
                }
            }
        },
        computed: {
            workflowEnum: function () {
                return workflowService.WorkflowEnum
            }
        },
        mounted () {
            loggingService.log(this.isDebug, 'LetterTemplates', 'mounted')
            this.loadWorkflowStatus()
            this.loadLookup()
        },
        methods: {
            loadLookup () {
                loggingService.log(this.isDebug, 'LetterTemplates', 'loadLookup')
                letterTemplateService.listLetterTemplateType(this.$http).then(response => {
                    this.templateTypeList = response.data
                    this.loadData()
                })
            },
            loadWorkflowStatus () {
                loggingService.log(this.isDebug, 'LetterTemplates', 'load workflow status')
                workflowService.listAllWorkflowStatus(this.$http).then(response => {
                    this.allWorkflowStatusList = response.data
                    this.allWorkflowStatusList.forEach(status => {
                        switch (status.workflowId) {
                        case this.workflowEnum.FieldworkRequest:
                            status.description = 'FWR - ' + status.description
                            break
                        case this.workflowEnum.FileSearch:
                            status.description = 'FIS - ' + status.description
                            break
                        case this.workflowEnum.Investigation:
                            status.description = 'INV - ' + status.description
                            break
                        case this.workflowEnum.SiteNumberRequest:
                            status.description = 'SNR - ' + status.description
                            break
                        case this.workflowEnum.CulturalResourceRecording:
                            status.description = 'CRR - ' + status.description
                            break
                        case this.workflowEnum.Isolate:
                            status.description = 'ISO - ' + status.description
                            break
                        case this.workflowEnum.BuildingSurvey:
                            status.description = 'BUS - ' + status.description
                            break
                        case this.workflowEnum.Undertaking:
                            status.description = 'UND - ' + status.description
                            break
                        case this.workflowEnum.Moa:
                            status.description = 'MOA - ' + status.description
                            break
                        case this.workflowEnum.Pa:
                            status.description = 'PA - ' + status.description
                            break
                        }
                    })
                })
            },
            loadData () {
                loggingService.log(this.isDebug, 'LetterTemplates', 'loadData')
                letterTemplateService.search(this.$http, this.searchDto).then(response => {
                    this.gridSpec.tableData = response.data
                    // set the templateType description
                    this.gridSpec.tableData.forEach(data => {
                        var matchedType = this.templateTypeList.find(type => { return type.id === data.letterTemplateTypeId })
                        data.templateType = matchedType ? matchedType.description : ''

                        var matchedWfStatus = this.allWorkflowStatusList.find(wf => { return wf.workflowStatusId === data.workflowStatusId })
                        data.workflowDescription = matchedWfStatus ? matchedWfStatus.description : ''
                    })
                    this.loading = false
                })
            },
            editRow (id) {
                loggingService.log(this.isDebug, 'LetterTemplates', 'editRow, id: ' + id)

                this.$router.push('/LetterTemplate/' + id)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// LetterTemplates.vue?8b4a0118